var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-app",class:{
	'c-dark-theme': _vm.$store.state.darkMode,
	// 'overflow-hidden': hideScroll,
}},[_c('TheSidebar'),_c('TheAside'),_c('CWrapper',[_c('TheHeader'),_c('div',{staticClass:"c-body"},[_c('main',{staticClass:"c-main",class:_vm.$route.path.includes('spend-dashboard')
				|| _vm.$route.path.includes('opportunity-identification')
				|| _vm.$route.path.includes('summary-dashboard')
				|| _vm.$route.path.includes('opportunity-dashboard')
				|| _vm.$route.path.includes('opportunity-list')
				|| _vm.$route.path.includes('opportunity-categories')
				|| _vm.$route.path.includes('achievement-dashboard')
				|| _vm.$route.path.includes('supply-spend')
				|| _vm.$route.path.includes('service-spend') ? 'custom-main' : '',style:(_vm.backgroundStyles)},[_c('CContainer',{class:_vm.$route.path.includes('spend-dashboard')
					|| _vm.$route.path.includes('opportunity-identification')
					|| _vm.$route.path.includes('summary-dashboard')
					|| _vm.$route.path.includes('opportunity-dashboard')
					|| _vm.$route.path.includes('opportunity-list')
					|| _vm.$route.path.includes('opportunity-categories')
					|| _vm.$route.path.includes('achievement-dashboard')
					|| _vm.$route.path.includes('supply-spend')
					|| _vm.$route.path.includes('service-spend') ? 'custom-fluid' : '',attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }